module.exports = __webpack_public_path__ + "static/media/bras.6b73d378.jpg";